import { historyFulfilledConstants, historyRejectedConstants } from '../actions';

const initialState = {
    historyList: [],
    historyDetails: null,
    error: ''
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case historyFulfilledConstants.HISTORY_LOADED:
            const reversedHistoryList = (payload && payload.reverse()) || [];
            return {
                ...state,
                historyList: reversedHistoryList
            };
        case historyFulfilledConstants.HISTORY_DETAILS_LOADED:
            return {
                ...state,
                historyDetails: payload
            };
        case historyRejectedConstants.HISTORY_LOADED:
        case historyRejectedConstants.HISTORY_DETAILS_LOADED: {
            const error = payload;

            let updatedState = {
                ...state,
                historyDetails: null
            };

            if (error.response) {
                updatedState = {
                    ...updatedState,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                updatedState = {
                    ...updatedState,
                    error: error.message
                };
            }

            return updatedState;
        }
        default:
            return state;
    }
}
